import { jsx as _jsx } from "react/jsx-runtime";
import React, { useCallback } from 'react';
/**
 * Base button component for all player controls.
 *
 * After a click, blurs the button so keyboard shortcuts (Space for
 * play/pause, arrow keys for seek) continue to work from the player
 * container rather than re-triggering the button. Uses onMouseUp
 * instead of onMouseDown+preventDefault so the browser's :active CSS
 * state is not suppressed.
 */
export const PlayerButton = React.memo(function PlayerButton({ tooltip, buttonRef, className, children, onClick, ...rest }) {
    const handleClick = useCallback((e) => {
        // Blur so the button doesn't keep focus (Space/Enter would re-trigger it)
        e.currentTarget.blur();
        onClick?.(e);
    }, [onClick]);
    return (_jsx("button", { ref: buttonRef, className: `hekate-player-btn ${className ?? ''}`, "aria-label": rest['aria-label'] ?? tooltip, "data-tooltip": tooltip, onClick: handleClick, type: "button", ...rest, children: children ?? _jsx("span", { className: "hekate-player-btn-icon", "aria-hidden": "true" }) }));
});
